import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbFormHooks from "abreact/form/AbFormHooks";
import { TextEditor } from "abreact/incubator/ui/kendo/TextEditor";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as React from "react";
export function AbHtmlEditor(props) {
  const {
    id,
    className,
    style,
    ...editorProps
  } = ReactUtils.inputProps("ab-html-editor", props, [props.resizable && "ab-resizable"]);
  const inputId = AbFormHooks.useInputId("ab-html-editor", props);
  return /*#__PURE__*/React.createElement(AbWithTooltip, {
    tooltip: props.tooltip
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className,
    style: style,
    "data-test-id": props.dataTestId
  }, /*#__PURE__*/React.createElement(TextEditor, _extends({}, editorProps, {
    id: inputId,
    value: props.value || null,
    resizable: props.resizable,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    placeholder: props.disabled ? undefined : props.placeholder
  }))));
}
//# sourceMappingURL=AbHtmlEditor.js.map
